"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultContext = {
    activeTab: '',
    idPrefix: '',
    setActiveTab: function () { }
};
var TabContext = (0, react_1.createContext)(defaultContext);
exports.default = TabContext;
